import { z } from 'zod'
import {
  companiesWithFullAccessSchema,
  companySchema,
  companyUserSchema,
  companyUserWithCompanyAndRoleSchema,
  companyUserWithCompanySchema,
  companyUserWithRoleAndPermissionsSchema,
  companyUserWithUserAndRoleSchema,
  companyUserWithUserSchema
} from '../schemas/companies.schemas'

export enum CompanyType {
  CONSTRUCTOR = 'constructor',
  PROVIDER = 'provider'
}

export enum CompanyUsersStatus {
  PENDING_USER = 'pending_user',
  PENDING_COMPANY = 'pending_company',
  ACTIVE = 'active'
}

export enum CompanyUsersRelation {
  EMPLOYEE = 'employee',
  CLIENT = 'client',
  PROVIDER = 'provider'
}

export type Company = z.infer<typeof companySchema>
export type CompanyUser = z.infer<typeof companyUserSchema>
export type CompanyUserWithCompany = z.infer<
  typeof companyUserWithCompanySchema
>
export type CompanyUserWithUser = z.infer<typeof companyUserWithUserSchema>

export type CompanyUserWithCompanyAndRole = z.infer<
  typeof companyUserWithCompanyAndRoleSchema
>

export type CompanyUserWithUserAndRole = z.infer<
  typeof companyUserWithUserAndRoleSchema
>
export type CompaniesWithFullAccess = z.infer<
  typeof companiesWithFullAccessSchema
>

export type CompanyUserWithRoleAndPermissions = z.infer<
  typeof companyUserWithRoleAndPermissionsSchema
>

export interface CompanyWithWorkspaces {
  id: string
  name: string
  workspaces: {
    id: string
    name: string
  }[]
}
